import { render } from "./OfficeAnalytics.vue?vue&type=template&id=7b94bd84&scoped=true"
import script from "./OfficeAnalytics.vue?vue&type=script&lang=js"
export * from "./OfficeAnalytics.vue?vue&type=script&lang=js"

import "./OfficeAnalytics.vue?vue&type=style&index=0&id=7b94bd84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b94bd84"]])

export default __exports__